import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        firstName: first_name
        lastName: last_name
        email
        phone
      }
      affiliate {
        status
        paypalAccount: paypal_account
      }
    }
  }
`

export const sendAffiliateMutation = graphql(
  gql`
    mutation sendAffiliateRequest($currency: String!, $file: String!, $paypalAccount: String, $paypalId: String) {
      sendAffiliateRequest(currency: $currency, file: $file, paypalAccount: $paypalAccount, paypalId: $paypalId) {
        status
      }
    }
  `,
  {
    name: 'sendAffiliateRequest'
  }
)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AffiliateAbout/data.ts